// The brand book's pattern (book.pdf, "Pattern", "Welcome" and "Graphical
// elements"; docs/design-system.md § Brand): the mark's four rounded forms,
// drawn as thin outlines, enlarged past the frame and cropped by it. It is the
// book's own graphic element, so it may stand where the mark itself may not:
// behind a hero's copy, on Paper or Ink. It is decoration only (aria-hidden).
//
// The forms are the official mark's paths (src/assets/signal-mark.svg), never
// redrawn, and they keep the mark's arrangement: four forms pointing in to a
// shared centre (BRK-S276). The outline is 1px at any size.
const FORMS = [
  // The top form.
  "M56.7305 21.2253C58.5329 23.0277 58.5329 25.9498 56.7305 27.7521L42.0079 42.4739C41.396 43.0856 40.6176 43.4292 39.8186 43.5048C38.7929 43.603 37.7331 43.2593 36.9476 42.4739L22.225 27.753C20.4225 25.9506 20.4225 23.0277 22.225 21.2253C24.0274 19.4231 26.9502 19.4231 28.7526 21.2253L39.4782 31.95L50.2028 21.2253C52.0053 19.423 54.9281 19.423 56.7305 21.2253Z",
  // The bottom form.
  "M56.7314 77.4769C58.5338 75.6745 58.5338 72.7524 56.7314 70.9501L42.0096 56.2283C41.5721 55.7908 41.0488 55.4908 40.4942 55.3275C39.2779 54.9674 37.9076 55.2675 36.9476 56.2275L22.225 70.9492C20.4229 72.7515 20.4228 75.6737 22.225 77.476C24.0274 79.2783 26.9502 79.2783 28.7526 77.476L39.4782 66.7513L50.2046 77.4769C52.007 79.2789 54.929 79.2789 56.7314 77.4769Z",
  // The right form.
  "M67.6013 66.6032C65.7989 68.4052 62.8769 68.4052 61.0745 66.6032L46.3519 51.8814C45.7398 51.2694 45.3965 50.4906 45.321 49.6913C45.2229 48.6658 45.5665 47.6056 46.3519 46.8203L61.0745 32.0994C62.877 30.297 65.7989 30.297 67.6013 32.0994C69.4036 33.9018 69.4037 36.8239 67.6013 38.6262L56.8758 49.3517L67.6013 60.0764C69.4037 61.8787 69.4038 64.8008 67.6013 66.6032Z",
  // The left form.
  "M11.3525 66.6021C13.1549 68.4042 16.0769 68.4042 17.8793 66.6021L32.6019 51.8804C33.34 51.1423 33.6873 50.1618 33.6451 49.1953C33.6083 48.332 33.261 47.4793 32.6019 46.8201L17.8793 32.0983C16.0769 30.296 13.1541 30.296 11.3516 32.0983C9.5494 33.9006 9.5495 36.8228 11.3516 38.6251L22.0772 49.3506L11.3525 60.0753C9.55008 61.8777 9.55007 64.7997 11.3525 66.6021Z",
] as const;

/** The crop of the enlarged mark that shows, framed as the book frames it:
 *  the left form whole, the top and bottom ones cut by the edges, the right
 *  one running out of the frame. In the mark's own units. */
const VIEW_BOX = "-12 26 72 46";

export function BrandPattern({ className = "" }: { className?: string }) {
  return (
    <svg
      data-brand-pattern
      viewBox={VIEW_BOX}
      preserveAspectRatio="xMaxYMid slice"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <g fill="none" stroke="currentColor" strokeWidth="1">
        {FORMS.map((d) => (
          <path key={d.slice(0, 16)} d={d} vectorEffect="non-scaling-stroke" />
        ))}
      </g>
    </svg>
  );
}
